import { TableProps } from 'antd/es/table';

import { Status } from '@Components/Base';

export const mapColumns: TableProps['columns'] = [
  {
    title: 'PR NO.',
    dataIndex: 'prNo',
    key: 'reqNo',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'REQUEST FROM',
    dataIndex: 'reqestFrom',
    key: 'reqFromId',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'TBMS MR NO./ERP PR NO.',
    dataIndex: 'tbmsErp',
    key: 'mrNo',
    sorter: false,
    ellipsis: true,
  },
  {
    title: 'MATERIAL GROUP',
    dataIndex: 'materialGroup',
    sorter: false,
    ellipsis: true,
  },
  {
    title: 'CLASSIFICATION',
    dataIndex: 'classification',
    key: 'classificationId',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'REQUEST DATE',
    dataIndex: 'requestDate',
    key: 'reqDate',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'REQUIRED DATE',
    dataIndex: 'requiredDate',
    key: 'requiredOn',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'STORE/PROJECT',
    dataIndex: 'storeProject',
    key: 'project',
    sorter: false,
    ellipsis: true,
  },
  {
    title: 'PURCHASE OFFICER',
    dataIndex: 'purchaseOfficer',
    key: 'approverNo',
    sorter: true,
    ellipsis: true,
  },
  {
    title: 'STATUS',
    dataIndex: 'status',
    key: 'statusId',
    sorter: true,
    render: (text) => <Status text={text} />,
  },
];
